import isEqual from 'lodash.isequal';
import * as React from 'react';
import Modal from 'react-modal';
import { IImage } from '../../../api/images';
import { displayableTags, formatOrientation, formatResolution, orOriginal } from '../../../entities/images/helpers';
import { Tag } from '../tag/Tag';
import { sortImages } from './helpers';

interface IPhotoLightboxProps extends Modal.Props {
	images: IImage[];
	index: number;
	isOpen: boolean;
	onRequestClose: () => void;
}

interface IPhotoLightboxState {
	currentImage: number;
	images: IImage[];
}

export class PhotoLightbox extends React.Component<IPhotoLightboxProps, IPhotoLightboxState> {
	constructor(props: IPhotoLightboxProps) {
		super(props);
		this.state = { currentImage: props.index, images: sortImages(props.images) };
	}

	public componentDidMount() {
		// Used to hide the rest of the application
		// from screen readers while the modal is open
		Modal.setAppElement('#root');
	}

	public componentDidUpdate(prevProps: IPhotoLightboxProps) {
		if (this.props.index !== prevProps.index) {
			this.setState({ currentImage: this.props.index });
		}
		if (!isEqual(this.props.images, prevProps.images)) {
			this.setState({ images: sortImages(this.props.images) });
		}
	}

	public render() {
		const { isOpen, onRequestClose } = this.props;
		const { currentImage, images } = this.state;
		const image = images[currentImage];
		const numberOfImages = images.length;

		if (!isOpen) return null;

		return <Modal
			overlayClassName="modal-overlay"
			className="modal"
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			shouldCloseOnOverlayClick={true}
		>
			<a className="lightbox__close" onClick={onRequestClose}>Close</a>
			<div className="lightbox__img-content">
				<a
					className={`lightbox__img-nav ${currentImage > 0 && `prev`}`}
					onClick={() => this.prevImage()}
				/>
				<img className="lightbox__img" src={image && orOriginal(image, '1024x768').url} />
				<a
					className={`lightbox__img-nav ${currentImage < numberOfImages - 1 && `next`}`}
					onClick={() => this.nextImage()}
				/>
			</div>
			<div className="lightbox__info">
				<div className="lightbox__info-metadata">
					<div className="lightbox__info_metadata-data">
						<p className="data__heading">Resolution</p>
						<p className="data__value">{formatResolution(image)}</p>
						<p className="data__heading">Orientation</p>
						<p className="data__value">{formatOrientation(image)}</p>
					</div>
				</div>
				<div className="lightbox__info-tags">
					<div className="lightbox__info_metadata-tags">
						<p className="data__heading">Tags</p>
						<div className="lightbox__data-tags">
							{displayableTags(image).map((tag, idx) => (
								<Tag type="content" key={idx}>{tag.object}</Tag>
							))}
						</div>
					</div>
				</div>
			</div>
		</Modal >;
	}

	private prevImage = () => {
		this.setState({ currentImage: this.state.currentImage - 1 });
	}

	private nextImage = () => {
		this.setState({ currentImage: this.state.currentImage + 1 });
	}

}
